<template>
  <div class="mision">
    <router-link
      to="/progreso"
      class="miperfil abs pointer"
      data-aos="fade-right"
      data-aos-delay="200"
    >
      <img
        src="../../../assets/imgs/mision/btn-mi-perfil.png"
        alt="Encauce"
        class="img-fluid w-100"
      />
    </router-link>

    <section
      class="pantalla mision1_1"
      v-bind:class="{
        bg1: reto == 0 || reto == 1,
        bg2: reto == 2 || reto == 3 || reto == 4 || reto == 5,
        bg3: reto == 6 || reto == 7 || reto == 8,
        bg4: reto == 9 || reto == 10,
        bg5: reto == 11 || reto == 12 || reto == 13,
        bg6: reto == 14 || reto == 15,
        bg7: reto == 16 || reto == 17 || reto == 18,
        bg8: reto == 19 || reto == 20,
        bg9: reto == 21 || reto == 22 || reto == 23,
        bg10: reto == 24 || reto == 25,
      }"
      v-if="!resultado && reto != -1"
    >
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 contentabs">
            <div class="pregunta abs" data-aos="fade-up" data-aos-delay="200">
              <img
                src="../../../assets/imgs/mision/bg-pregunta-trapezoide.png"
                alt="Encauce"
                class="img-fluid w-100"
              />
              <div
                class="pregunta_txt abs"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <div class="blanco bold" v-html="retos[reto].texto"></div>
                <div class="electrico" v-html="retos[reto].instruccion"></div>
              </div>
            </div>

            <div class="quasar abs" data-aos="fade-up" data-aos-delay="200">
              <img
                src="../../../assets/imgs/mision/quasar-verde.png"
                alt="Encauce"
                class="img-fluid"
              />
            </div>

            <div
              @click="avanzar"
              class="btnavanzar abs"
              data-aos="fade-left"
              data-aos-delay="200"
            >
              <img
                src="../../../assets/imgs/mision/bg-flecha-siguiente.png"
                alt="Encauce"
                class="img-fluid"
              />
              <div class="texto electrico d-flex flex-column">
                <span>Presiona la flecha </span>
                <span class="bold">para continuar</span>
              </div>
            </div>

            <div
              @click="retroceder"
              class="btnretroceder abs"
              data-aos="fade-left"
              data-aos-delay="200"
              v-if="this.reto > 0"
            >
              <img
                src="../../../assets/imgs/mision/bg-flecha-atras.png"
                alt="Encauce"
                class="img-fluid"
              />
              <div class="texto electrico d-flex flex-column">
                <span>Regresar al </span>
                <span class="bold">reto anterior</span>
              </div>
            </div>

            <div
              @click="toggleOraculo"
              class="oraculo abs"
              data-aos="fade-left"
              data-aos-delay="200"
            >
              <img
                src="../../../assets/imgs/mision/oraculo.png"
                alt="Encauce"
                class="img-fluid w100 btnoraculo"
              />
              <div
                class="dialogo"
                :class="{ active: oraculo === true && tip_oraculo != null }"
              >
                <img
                  src="../../../assets/imgs/mision/dialogo-oraculo.png"
                  alt="Encauce"
                  class="img-fluid"
                />
                <div class="cerrar blanco bold">x</div>
                <div class="titulo cyan bold uppercase">
                  {{ tip_oraculo.tipo }}
                </div>
                <div class="texto blanco text-center">
                  {{ tip_oraculo.texto }}
                </div>
              </div>
            </div>

            <!---->

            <div class="dinamica" v-if="this.retoObj != null">
              <div class="info" data-aos="fade-right" data-aos-delay="600">
                <img
                  class="img-fluid w-100"
                  :src="
                    require('../../../assets/imgs/mision/3/' +
                      retoObj.campo +
                      '/bg-profesor.png')
                  "
                  alt="nivel3"
                />
                <div class="contenido w-100 px5 pt5 h-100">
                  <div class="nombre electrico text-right">
                    <span class="fpG">PROFESOR_</span><br />
                    <span class="fpXXG bold">{{ retoObj.profesor }}</span>
                  </div>
                  <div class="materia text-right">
                    <img
                      :src="
                        require('../../../assets/imgs/mision/3/' +
                          retoObj.campo +
                          '/materia.png')
                      "
                      alt="materia"
                      class="img-fluid"
                    />
                  </div>
                  <div class="profesor">
                    <img
                      :src="
                        require('../../../assets/imgs/mision/3/' +
                          retoObj.campo +
                          '/profesor.png')
                      "
                      alt="profesor"
                      class="img-fluid"
                    />
                  </div>
                </div>
              </div>
              <div class="opciones" data-aos="fade-left" data-aos-delay="1000">
                <img
                  class="img-fluid w-100"
                  :src="
                    require('../../../assets/imgs/mision/3/' +
                      retoObj.campo +
                      '/bg-opciones.png')
                  "
                  alt="nivel3"
                />
                <div class="contenedor">
                  <div
                    class="opcion opcion1"
                    v-if="
                      retoObj.preguntas.opcion1 != null && fortaleza != null
                    "
                  >
                    <div
                      v-if="
                        fortaleza ==
                        'habilidad_' + retoObj.preguntas.opcion1.tipo
                      "
                      class="fortaleza w-100 electrico d-flex justify-content-center align-items-center"
                    >
                      <img
                        class="img-fluid pr2"
                        src="../../../assets/imgs/mision/estrellita.png"
                        alt="estrella"
                      />
                      <span class="fpC bold"
                        >TIENES LA FORTALEZA PARA LOGRARLO</span
                      >
                    </div>
                    <div class="icono w-100 text-center">
                      <img
                        class="img-fluid"
                        :src="
                          require('../../../assets/imgs/mision/3/iconos/icono-' +
                            retoObj.id +
                            '-1.png')
                        "
                        alt="icono"
                      />
                      <div class="texto fpG electrico px6">
                        {{ retoObj.preguntas.opcion1.texto }}
                      </div>
                    </div>
                    <div
                      class="barra electrico d-flex justify-content-center fpG1 bold"
                    >
                      <div
                        class="d-flex justify-content-center align-items-center contcheck pointer"
                        @click="
                          selectRespuesta(
                            1,
                            'gusto',
                            retoObj.campo,
                            retoObj.preguntas.opcion1.tipo,
                            retoObj.preguntas.opcion1.campo_especifico
                          )
                        "
                      >
                        <span>ME GUSTA O INTERESA</span>
                        <div class="check">
                          <img
                            class="img-fluid box"
                            src="../../../assets/imgs/mision/checkbox.png"
                            alt="checkbox"
                          />
                          <div
                            class="paloma"
                            v-show="selecciones.opcion1.gusto === true"
                          >
                            <img
                              class="img-fluid check"
                              src="../../../assets/imgs/mision/check.png"
                              alt="check"
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        class="d-flex justify-content-center align-items-center contcheck pointer"
                        @click="
                          selectRespuesta(
                            1,
                            'habilidad',
                            retoObj.campo,
                            retoObj.preguntas.opcion1.tipo,
                            retoObj.preguntas.opcion1.campo_especifico
                          )
                        "
                      >
                        <span>TENGO HABILIDADES</span>
                        <div class="check">
                          <img
                            class="img-fluid box"
                            src="../../../assets/imgs/mision/checkbox.png"
                            alt="checkbox"
                          />
                          <div
                            class="paloma"
                            v-show="selecciones.opcion1.habilidad === true"
                          >
                            <img
                              class="img-fluid check"
                              src="../../../assets/imgs/mision/check.png"
                              alt="check"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="opcion opcion2"
                    v-if="
                      retoObj.preguntas.opcion2 != null && fortaleza != null
                    "
                  >
                    <div
                      v-if="
                        fortaleza ===
                        'habilidad_' + retoObj.preguntas.opcion2.tipo
                      "
                      class="fortaleza w-100 electrico d-flex justify-content-center align-items-center"
                    >
                      <img
                        class="img-fluid pr2"
                        src="../../../assets/imgs/mision/estrellita.png"
                        alt="estrella"
                      />
                      <span class="fpC bold"
                        >TIENES LA FORTALEZA PARA LOGRARLO</span
                      >
                    </div>
                    <div class="icono w-100 text-center">
                      <img
                        class="img-fluid"
                        :src="
                          require('../../../assets/imgs/mision/3/iconos/icono-' +
                            retoObj.id +
                            '-2.png')
                        "
                        alt="icono"
                      />
                      <div class="texto fpG electrico px6">
                        {{ retoObj.preguntas.opcion2.texto }}
                      </div>
                    </div>
                    <div
                      class="barra electrico d-flex justify-content-center fpG1 bold"
                    >
                      <div
                        class="d-flex justify-content-center align-items-center contcheck pointer"
                        @click="
                          selectRespuesta(
                            2,
                            'gusto',
                            retoObj.campo,
                            retoObj.preguntas.opcion2.tipo,
                            retoObj.preguntas.opcion2.campo_especifico
                          )
                        "
                      >
                        <span>ME GUSTA O INTERESA</span>
                        <div class="check">
                          <img
                            class="img-fluid box"
                            src="../../../assets/imgs/mision/checkbox.png"
                            alt="checkbox"
                          />
                          <div
                            class="paloma"
                            v-show="selecciones.opcion2.gusto === true"
                          >
                            <img
                              class="img-fluid check"
                              src="../../../assets/imgs/mision/check.png"
                              alt="check"
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        class="d-flex justify-content-center align-items-center contcheck pointer"
                        @click="
                          selectRespuesta(
                            2,
                            'habilidad',
                            retoObj.campo,
                            retoObj.preguntas.opcion2.tipo,
                            retoObj.preguntas.opcion2.campo_especifico
                          )
                        "
                      >
                        <span>TENGO HABILIDADES</span>
                        <div class="check">
                          <img
                            class="img-fluid box"
                            src="../../../assets/imgs/mision/checkbox.png"
                            alt="checkbox"
                          />
                          <div
                            class="paloma"
                            v-show="selecciones.opcion2.habilidad === true"
                          >
                            <img
                              class="img-fluid check"
                              src="../../../assets/imgs/mision/check.png"
                              alt="check"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="hidden abs">
      <img src="../../../assets/imgs/mision/3/1/bg.jpg" alt="precarga" />
      <img src="../../../assets/imgs/mision/3/2/bg.jpg" alt="precarga" />
      <img src="../../../assets/imgs/mision/3/3/bg.jpg" alt="precarga" />
      <img src="../../../assets/imgs/mision/3/4/bg.jpg" alt="precarga" />
      <img src="../../../assets/imgs/mision/3/5/bg.jpg" alt="precarga" />
      <img src="../../../assets/imgs/mision/3/6/bg.jpg" alt="precarga" />
      <img src="../../../assets/imgs/mision/3/7/bg.jpg" alt="precarga" />
      <img src="../../../assets/imgs/mision/3/8/bg.jpg" alt="precarga" />
      <img src="../../../assets/imgs/mision/3/9/bg.jpg" alt="precarga" />
      <img src="../../../assets/imgs/mision/3/10/bg.jpg" alt="precarga" />
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import AOS from "aos";
import { mapState } from "vuex";
import swal from "sweetalert2";
import router from "../../../router/index";

export default {
  components: {
    Footer,
  },
  data() {
    return {
      loginForm: {
        email: "",
        password: "",
      },
      signupForm: {
        nombre: "",
        apellido: "",
        email: "",
        celular: "",
        password: "",
        fecha_nacimiento: "",
        monedero: "",
      },
      tip_oraculo: null,
      showLoginForm: true,
      showPasswordReset: false,
      showMonedero: false,
      dateType: "text",
      res: -1,
      oraculo: false,
      resultado: false,
      time: 0,
      mision: 3,
      reto: -1,
      retoObj: null,
      dragData: {},
      lista_ordenada: null,
      habilidad: [
        "procedimental",
        "empatico",
        "analitico",
        "creativo",
        "perfeccionista",
      ],
      retos: [
        {
          id: 1,
          profesor: "KITT X3",
          campo: 1,
          texto:
            "Como parte de tu preparación en la academia N-kau 3, tomarás un test con el androide correspondiente a la materia.",
          instruccion:
            "Selecciona en el test lo que te interesa y si tienes habilidades para realizarlo, dando clic en los checkboxes. Las <span class='bold fpG2'>actividades con estrellas</span> indican que tu fortaleza te favorece para aprenderlas de manera fluida.",
          preguntas: {
            opcion1: {
              texto: "Crear material de apoyo para la enseñanza.",
              tipo: 1,
              campo_especifico: 1,
            },
            opcion2: {
              texto:
                "Diseñar, organizar y desarrollar situaciones que favorezcan el aprendizaje.",
              tipo: 1,
              campo_especifico: 1,
            },
          },
        },
        {
          id: 2,
          profesor: "KITT X3",
          campo: 1,
          texto:
            "Como parte de tu preparación en la academia N-kau 3, tomarás un test con el androide correspondiente a la materia.",
          instruccion:
            "Selecciona en el test lo que te interesa y si tienes habilidades para realizarlo, dando clic en los checkboxes. Las <span class='bold fpG2'>actividades con estrellas</span> indican que tu fortaleza te favorece para aprenderlas de manera fluida.",
          preguntas: {
            opcion1: {
              texto: "Educar a niños, jóvenes o adultos.",
              tipo: 1,
              campo_especifico: 2,
            },
            opcion2: {
              texto: "Enseñar, convivir y apoyar a niños pequeños.",
              tipo: 1,
              campo_especifico: 2,
            },
          },
        },
        {
          id: 3,
          profesor: "MEGA 4K",
          campo: 2,
          texto:
            "Como parte de tu preparación en la academia N-kau 3, tomarás un test con el androide correspondiente a la materia.",
          instruccion:
            "Selecciona en el test lo que te interesa y si tienes habilidades para realizarlo, dando clic en los checkboxes. Las <span class='bold fpG2'>actividades con estrellas</span> indican que tu fortaleza te favorece para aprenderlas de manera fluida.",
          preguntas: {
            opcion1: {
              texto:
                "Crear objetos de uso cotidiano con un sentido estético y funcional.",
              tipo: 3,
              campo_especifico: 3,
            },
            opcion2: {
              texto: "Pintar cuadros, dibujar o crear esculturas.",
              tipo: 3,
              campo_especifico: 3,
            },
          },
        },
        {
          id: 4,
          profesor: "MEGA 4K",
          campo: 2,
          texto:
            "Como parte de tu preparación en la academia N-kau 3, tomarás un test con el androide correspondiente a la materia.",
          instruccion:
            "Selecciona en el test lo que te interesa y si tienes habilidades para realizarlo, dando clic en los checkboxes. Las <span class='bold fpG2'>actividades con estrellas</span> indican que tu fortaleza te favorece para aprenderlas de manera fluida.",
          preguntas: {
            opcion1: {
              texto: "Producir mensajes visuales y/o audiovisuales.",
              tipo: 3,
              campo_especifico: 3,
            },
            opcion2: {
              texto:
                "Participar en procesos escénicos: actuar, cantar, bailar, realizar acrobacias y otras habilidades.",
              tipo: 1,
              campo_especifico: 3,
            },
          },
        },
        {
          id: 5,
          profesor: "MEGA 4K",
          campo: 2,
          texto:
            "Como parte de tu preparación en la academia N-kau 3, tomarás un test con el androide correspondiente a la materia.",
          instruccion:
            "Selecciona en el test lo que te interesa y si tienes habilidades para realizarlo, dando clic en los checkboxes. Las <span class='bold fpG2'>actividades con estrellas</span> indican que tu fortaleza te favorece para aprenderlas de manera fluida.",
          preguntas: {
            opcion1: {
              texto:
                "Analizar temas relacionados con el pensamiento de la humanidad.",
              tipo: 2,
              campo_especifico: 4,
            },
            opcion2: {
              texto: "Tocar algún instrumento, cantar o componer música.",
              tipo: 1,
              campo_especifico: 3,
            },
          },
        },
        {
          id: 6,
          profesor: "MEGA 4K",
          campo: 2,
          texto:
            "Como parte de tu preparación en la academia N-kau 3, tomarás un test con el androide correspondiente a la materia.",
          instruccion:
            "Selecciona en el test lo que te interesa y si tienes habilidades para realizarlo, dando clic en los checkboxes. Las <span class='bold fpG2'>actividades con estrellas</span> indican que tu fortaleza te favorece para aprenderlas de manera fluida.",
          preguntas: {
            opcion1: {
              texto: "Conocer la historia y cultura de un pueblo o país.",
              tipo: 1,
              campo_especifico: 4,
            },
            opcion2: {
              texto:
                "Dominar los aspectos relacionados con la lengua, su estructura, evolución, normas y enfoques de estudio.",
              tipo: 1,
              campo_especifico: 4,
            },
          },
        },
        {
          id: 7,
          profesor: "GERTY Z",
          campo: 3,
          texto:
            "Como parte de tu preparación en la academia N-kau 3, tomarás un test con el androide correspondiente a la materia.",
          instruccion:
            "Selecciona en el test lo que te interesa y si tienes habilidades para realizarlo, dando clic en los checkboxes. Las <span class='bold fpG2'>actividades con estrellas</span> indican que tu fortaleza te favorece para aprenderlas de manera fluida.",
          preguntas: {
            opcion1: {
              texto:
                "Observar, escuchar y analizar cómo se sienten las personas.",
              tipo: 1,
              campo_especifico: 5,
            },
            opcion2: {
              texto:
                "Analizar los problemas de la sociedad y buscar las causas en su historia y cultura.",
              tipo: 1,
              campo_especifico: 5,
            },
          },
        },
        {
          id: 8,
          profesor: "GERTY Z",
          campo: 3,
          texto:
            "Como parte de tu preparación en la academia N-kau 3, tomarás un test con el androide correspondiente a la materia.",
          instruccion:
            "Selecciona en el test lo que te interesa y si tienes habilidades para realizarlo, dando clic en los checkboxes. Las <span class='bold fpG2'>actividades con estrellas</span> indican que tu fortaleza te favorece para aprenderlas de manera fluida.",
          preguntas: {
            opcion1: {
              texto: "Realizar investigación documental.",
              tipo: 0,
              campo_especifico: 6,
            },
            opcion2: {
              texto:
                "Crear productos para medios de comunicación (entrevistas, reportajes, etc.)",
              tipo: 0,
              campo_especifico: 6,
            },
          },
        },
        {
          id: 9,
          profesor: "GERTY Z",
          campo: 3,
          texto:
            "Como parte de tu preparación en la academia N-kau 3, tomarás un test con el androide correspondiente a la materia.",
          instruccion:
            "Selecciona en el test lo que te interesa y si tienes habilidades para realizarlo, dando clic en los checkboxes. Las <span class='bold fpG2'>actividades con estrellas</span> indican que tu fortaleza te favorece para aprenderlas de manera fluida.",
          preguntas: {
            opcion1: {
              texto:
                "Estudiar el delito, la delincuencia, el delincuente, la víctima y los medios de control social.",
              tipo: 0,
              campo_especifico: 7,
            },
            opcion2: {
              texto: "Conocer sobre leyes y defender a las personas.",
              tipo: 2,
              campo_especifico: 7,
            },
          },
        },
        {
          id: 10,
          profesor: "HK-47",
          campo: 4,
          texto:
            "Como parte de tu preparación en la academia N-kau 3, tomarás un test con el androide correspondiente a la materia.",
          instruccion:
            "Selecciona en el test lo que te interesa y si tienes habilidades para realizarlo, dando clic en los checkboxes. Las <span class='bold fpG2'>actividades con estrellas</span> indican que tu fortaleza te favorece para aprenderlas de manera fluida.",
          preguntas: {
            opcion1: {
              texto:
                "Diseñar y gestionar estrategias para el correcto funcionamiento de operaciones comerciales.",
              tipo: 2,
              campo_especifico: 8,
            },
            opcion2: {
              texto: "Entender cómo funcionan la contabilidad y las finanzas.",
              tipo: 0,
              campo_especifico: 8,
            },
          },
        },
        {
          id: 11,
          profesor: "HK-47",
          campo: 4,
          texto:
            "Como parte de tu preparación en la academia N-kau 3, tomarás un test con el androide correspondiente a la materia.",
          instruccion:
            "Selecciona en el test lo que te interesa y si tienes habilidades para realizarlo, dando clic en los checkboxes. Las <span class='bold fpG2'>actividades con estrellas</span> indican que tu fortaleza te favorece para aprenderlas de manera fluida.",
          preguntas: {
            opcion1: {
              texto:
                "Diseñar sistemas de trabajo, ordenando distintas tareas de una empresa o institución.",
              tipo: 0,
              campo_especifico: 9,
            },
            opcion2: {
              texto:
                "Crear estrategias para hacer crecer una empresa o negocio.",
              tipo: 3,
              campo_especifico: 9,
            },
          },
        },
        {
          id: 12,
          profesor: "BRILLBIT",
          campo: 5,
          texto:
            "Como parte de tu preparación en la academia N-kau 3, tomarás un test con el androide correspondiente a la materia.",
          instruccion:
            "Selecciona en el test lo que te interesa y si tienes habilidades para realizarlo, dando clic en los checkboxes. Las <span class='bold fpG2'>actividades con estrellas</span> indican que tu fortaleza te favorece para aprenderlas de manera fluida.",
          preguntas: {
            opcion1: {
              texto:
                "Desarrollar proyectos o acciones para el cuidado del medio ambiente.",
              tipo: 1,
              campo_especifico: 10,
            },
            opcion2: {
              texto: "Observar y entender los fenómenos de la naturaleza.",
              tipo: 0,
              campo_especifico: 10,
            },
          },
        },
        {
          id: 13,
          profesor: "BRILLBIT",
          campo: 5,
          texto:
            "Como parte de tu preparación en la academia N-kau 3, tomarás un test con el androide correspondiente a la materia.",
          instruccion:
            "Selecciona en el test lo que te interesa y si tienes habilidades para realizarlo, dando clic en los checkboxes. Las <span class='bold fpG2'>actividades con estrellas</span> indican que tu fortaleza te favorece para aprenderlas de manera fluida.",
          preguntas: {
            opcion1: {
              texto: "Realizar experimentos químicos en un laboratorio.",
              tipo: 2,
              campo_especifico: 11,
            },
            opcion2: {
              texto: "Conocer las propiedades de la materia y energía.",
              tipo: 2,
              campo_especifico: 11,
            },
          },
        },
        {
          id: 14,
          profesor: "BRILLBIT",
          campo: 5,
          texto:
            "Como parte de tu preparación en la academia N-kau 3, tomarás un test con el androide correspondiente a la materia.",
          instruccion:
            "Selecciona en el test lo que te interesa y si tienes habilidades para realizarlo, dando clic en los checkboxes. Las <span class='bold fpG2'>actividades con estrellas</span> indican que tu fortaleza te favorece para aprenderlas de manera fluida.",
          preguntas: {
            opcion1: {
              texto: "Elaborar gráficas para resumir información numérica.",
              tipo: 12,
              campo_especifico: 1,
            },
            opcion2: {
              texto: "Realizar ecuaciones y aprender de estadísticas.",
              tipo: 12,
              campo_especifico: 1,
            },
          },
        },
        {
          id: 15,
          profesor: "OTBROID",
          campo: 6,
          texto:
            "Como parte de tu preparación en la academia N-kau 3, tomarás un test con el androide correspondiente a la materia.",
          instruccion:
            "Selecciona en el test lo que te interesa y si tienes habilidades para realizarlo, dando clic en los checkboxes. Las <span class='bold fpG2'>actividades con estrellas</span> indican que tu fortaleza te favorece para aprenderlas de manera fluida.",
          preguntas: {
            opcion1: {
              texto: "Manejar computadoras y aprender sobre nuevos programas.",
              tipo: 0,
              campo_especifico: 13,
            },
            opcion2: {
              texto:
                "Conocer cómo funcionan los celulares, videojuegos o internet.",
              tipo: 3,
              campo_especifico: 13,
            },
          },
        },
        {
          id: 16,
          profesor: "OTBROID",
          campo: 6,
          texto:
            "Como parte de tu preparación en la academia N-kau 3, tomarás un test con el androide correspondiente a la materia.",
          instruccion:
            "Selecciona en el test lo que te interesa y si tienes habilidades para realizarlo, dando clic en los checkboxes. Las <span class='bold fpG2'>actividades con estrellas</span> indican que tu fortaleza te favorece para aprenderlas de manera fluida.",
          preguntas: {
            opcion1: {
              texto:
                "Desarrollar aplicaciones web, administración y gestión de redes de comunicaciones.",
              tipo: 2,
              campo_especifico: 13,
            },
            opcion2: {
              texto:
                "Diseñar métodos, técnicas y procesos para almacenar, procesar y transmitir información y datos de manera digital.",
              tipo: 0,
              campo_especifico: 13,
            },
          },
        },
        {
          id: 17,
          profesor: "ENK",
          campo: 7,
          texto:
            "Como parte de tu preparación en la academia N-kau 3, tomarás un test con el androide correspondiente a la materia.",
          instruccion:
            "Selecciona en el test lo que te interesa y si tienes habilidades para realizarlo, dando clic en los checkboxes. Las <span class='bold fpG2'>actividades con estrellas</span> indican que tu fortaleza te favorece para aprenderlas de manera fluida.",
          preguntas: {
            opcion1: {
              texto: "Entender el funcionamiento de máquinas robotizadas.",
              tipo: 2,
              campo_especifico: 14,
            },
            opcion2: {
              texto: "Conocer el funcionamiento de los autos y los motores.",
              tipo: 0,
              campo_especifico: 14,
            },
          },
        },
        {
          id: 18,
          profesor: "ENK",
          campo: 7,
          texto:
            "Como parte de tu preparación en la academia N-kau 3, tomarás un test con el androide correspondiente a la materia.",
          instruccion:
            "Selecciona en el test lo que te interesa y si tienes habilidades para realizarlo, dando clic en los checkboxes. Las <span class='bold fpG2'>actividades con estrellas</span> indican que tu fortaleza te favorece para aprenderlas de manera fluida.",
          preguntas: {
            opcion1: {
              texto:
                "Investigar e innovar en productos y procesos del área alimentaria.",
              tipo: 0,
              campo_especifico: 15,
            },
            opcion2: {
              texto:
                "Trabajar con minerales existentes en la naturaleza y aprovecharlos de manera óptima.",
              tipo: 2,
              campo_especifico: 15,
            },
          },
        },
        {
          id: 19,
          profesor: "ENK",
          campo: 7,
          texto:
            "Como parte de tu preparación en la academia N-kau 3, tomarás un test con el androide correspondiente a la materia.",
          instruccion:
            "Selecciona en el test lo que te interesa y si tienes habilidades para realizarlo, dando clic en los checkboxes. Las <span class='bold fpG2'>actividades con estrellas</span> indican que tu fortaleza te favorece para aprenderlas de manera fluida.",
          preguntas: {
            opcion1: {
              texto:
                "Realizar maquetas digitales para el diseño urbano de poblaciones.",
              tipo: 2,
              campo_especifico: 16,
            },
            opcion2: {
              texto:
                "Diseñar casas, edificios o ambientar espacios para que sean más agradables.",
              tipo: 3,
              campo_especifico: 16,
            },
          },
        },
        {
          id: 20,
          profesor: "ROB BITT",
          campo: 8,
          texto:
            "Como parte de tu preparación en la academia N-kau 3, tomarás un test con el androide correspondiente a la materia.",
          instruccion:
            "Selecciona en el test lo que te interesa y si tienes habilidades para realizarlo, dando clic en los checkboxes. Las <span class='bold fpG2'>actividades con estrellas</span> indican que tu fortaleza te favorece para aprenderlas de manera fluida.",
          preguntas: {
            opcion1: {
              texto: "Estudiar los bosques y la lucha por su conservación.",
              tipo: 0,
              campo_especifico: 17,
            },
            opcion2: {
              texto: "Diseñar planes de desarrollo agrícola y ganadero.",
              tipo: 0,
              campo_especifico: 17,
            },
          },
        },
        {
          id: 21,
          profesor: "ROB BITT",
          campo: 8,
          texto:
            "Como parte de tu preparación en la academia N-kau 3, tomarás un test con el androide correspondiente a la materia.",
          instruccion:
            "Selecciona en el test lo que te interesa y si tienes habilidades para realizarlo, dando clic en los checkboxes. Las <span class='bold fpG2'>actividades con estrellas</span> indican que tu fortaleza te favorece para aprenderlas de manera fluida.",
          preguntas: {
            opcion1: {
              texto: "Prevenir enfermedades perjudiciales a los animales.",
              tipo: 0,
              campo_especifico: 18,
            },
            opcion2: {
              texto: "Aprender sobre los animales y sus cuidados.",
              tipo: 0,
              campo_especifico: 18,
            },
          },
        },
        {
          id: 22,
          profesor: "ECX",
          campo: 9,
          texto:
            "Como parte de tu preparación en la academia N-kau 3, tomarás un test con el androide correspondiente a la materia.",
          instruccion:
            "Selecciona en el test lo que te interesa y si tienes habilidades para realizarlo, dando clic en los checkboxes. Las <span class='bold fpG2'>actividades con estrellas</span> indican que tu fortaleza te favorece para aprenderlas de manera fluida.",
          preguntas: {
            opcion1: {
              texto: "Cuidar y promover la salud de las personas.",
              tipo: 2,
              campo_especifico: 19,
            },
            opcion2: {
              texto:
                "Conocer cómo puede combinarse la medicina con la tecnología.",
              tipo: 2,
              campo_especifico: 19,
            },
          },
        },
        {
          id: 23,
          profesor: "ECX",
          campo: 9,
          texto:
            "Como parte de tu preparación en la academia N-kau 3, tomarás un test con el androide correspondiente a la materia.",
          instruccion:
            "Selecciona en el test lo que te interesa y si tienes habilidades para realizarlo, dando clic en los checkboxes. Las <span class='bold fpG2'>actividades con estrellas</span> indican que tu fortaleza te favorece para aprenderlas de manera fluida.",
          preguntas: {
            opcion1: {
              texto: "Ciudar de la salud bucal.",
              tipo: 0,
              campo_especifico: 21,
            },
            opcion2: {
              texto: "Procurar el bienestar de los enfermos.",
              tipo: 0,
              campo_especifico: 20,
            },
          },
        },
        {
          id: 24,
          profesor: "ECX",
          campo: 9,
          texto:
            "Como parte de tu preparación en la academia N-kau 3, tomarás un test con el androide correspondiente a la materia.",
          instruccion:
            "Selecciona en el test lo que te interesa y si tienes habilidades para realizarlo, dando clic en los checkboxes. Las <span class='bold fpG2'>actividades con estrellas</span> indican que tu fortaleza te favorece para aprenderlas de manera fluida.",
          preguntas: {
            opcion1: {
              texto:
                "Salvaguardar la salud de las personas a través de la alimentación.",
              tipo: 0,
              campo_especifico: 22,
            },
            opcion2: {
              texto:
                "Conocer herramientas y técnicas de la rehabilitación física.",
              tipo: 0,
              campo_especifico: 22,
            },
          },
        },
        {
          id: 25,
          profesor: "AZERTY",
          campo: 10,
          texto:
            "Como parte de tu preparación en la academia N-kau 3, tomarás un test con el androide correspondiente a la materia.",
          instruccion:
            "Selecciona en el test lo que te interesa y si tienes habilidades para realizarlo, dando clic en los checkboxes. Las <span class='bold fpG2'>actividades con estrellas</span> indican que tu fortaleza te favorece para aprenderlas de manera fluida.",
          preguntas: {
            opcion1: {
              texto:
                "Estudiar la ciencia y arte de la relación entre el ser humano y su alimentación.",
              tipo: 3,
              campo_especifico: 23,
            },
            opcion2: {
              texto: "Diseñar y crear programas deportivos.",
              tipo: 0,
              campo_especifico: 23,
            },
          },
        },
        {
          id: 26,
          profesor: "AZERTY",
          campo: 10,
          texto:
            "Como parte de tu preparación en la academia N-kau 3, tomarás un test con el androide correspondiente a la materia.",
          instruccion:
            "Selecciona en el test lo que te interesa y si tienes habilidades para realizarlo, dando clic en los checkboxes. Las <span class='bold fpG2'>actividades con estrellas</span> indican que tu fortaleza te favorece para aprenderlas de manera fluida.",
          preguntas: {
            opcion1: {
              texto:
                "Diseñar y evaluar programas de prevención social para ofrecer seguridad a la población.",
              tipo: 0,
              campo_especifico: 24,
            },
            opcion2: null,
          },
        },
      ],
      respuestas_usuario: [],
      avance: null,
      x: null,
      y: null,
      resultado_evaluacion: null,
      valores: [4, 3, 2, 1],
      suma: {
        habilidad_0: 0,
        habilidad_1: 0,
        habilidad_2: 0,
        habilidad_3: 0,
      },
      tipo_reto: null,
      tache: "tache",
      check: "check",
      seleccionado_check: null,
      seleccionado_tache: null,
      tipo_seleccionado: null,
      dragging: false,
      selecciones: {
        opcion1: {
          gusto: false,
          habilidad: false,
          campo_especifico: null,
        },
        opcion2: {
          gusto: false,
          habilidad: false,
          campo_especifico: null,
        },
        campo: -1,
      },
      fortaleza: null,
      competencias: null,
      campos_aptos: [],
      competenciasObj: {},
    };
  },
  computed: {
    ...mapState(["userProfile", "institucionID"]),
  },
  watch: {
    $route(to, from) {
      // react to route changes...
      console.log("cambio de ruta");

      this.initiated = false;

      this.init();
    },
    userProfile(value) {
      //if (value) alert(this.userProfile.nombre)
      if (value) this.init();
    },
  },
  mounted: function () {
    this.init();
  },
  methods: {
    init() {
      if (this.userProfile == null || this.initiated == true) {
        return;
      }

      console.log("iniciando mision " + this.mision);

      this.initiated = true;

      /////////////////////
      this.reto = this.$route.params.reto - 1;
      this.retoObj = this.retos[this.reto];
      console.log({ retoObj: this.retoObj });

      this.tipo_reto = this.retos[this.reto].tipo;
      this.res = -1;

      this.selecciones = {
        opcion1: {
          gusto: false,
          habilidad: false,
          campo_especifico: null,
        },
        opcion2: {
          gusto: false,
          habilidad: false,
          campo_especifico: null,
        },
        campo: -1,
      };

      this.setRespuestasUsuario();

      AOS.init({
        offset: -120, // offset (in px) from the original trigger point
        delay: 0, // values from 0 to 3000, with step 50ms
        duration: 800, // values from 0 to 3000, with step 50ms
        easing: "ease-in-out", // default easing for AOS animations
        once: false, // whether animation should happen only once - while scrolling down
        mirror: false, // whether elements should animate out while scrolling past them
        anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
      });

      this.getOraculo();
    },
    getOraculo() {
      let oraculo = this.$store.state.oraculo;
      let rand = Math.floor(Math.random() * (oraculo.length - 1)) + 0;
      this.tip_oraculo = oraculo[rand];
    },
    async setRespuestasUsuario() {
      console.log({ retonum: this.reto });
      if (this.reto == 0) {
        await this.getFortaleza();
        await this.getAvance();
      } else {
        await this.getLocalStorage();
      }

      console.log({ respuestas_usuario: this.respuestas_usuario });
    },
    async getLocalStorage() {},
    async getAvance() {
      console.log({ reto: this.reto });
      this.avance = await this.$store.dispatch("getAvance");
      this.respuestas_usuario = this.avance.misiones[
        this.mision - 1
      ].respuestas;

      this.fortaleza = this.avance.misiones[1].fortaleza;
      this.competencias = this.avance.misiones[1].competencias;

      this.competenciasObj = {};
      for (var i = 0; i < 4; i++) {
        if (this.competencias[i] != null) {
          console.log({ hey: this.competencias[i][0] });
          this.competenciasObj[this.competencias[i][0]] = this.competencias[
            i
          ][1];
        }
      }

      console.log({ fortaleza: this.fortaleza });
      console.log({ competencias: this.competencias });
      console.log({ competenciasObj: this.competenciasObj });

      let inIdsPrueba = await this.$store.dispatch("inIdsPrueba");

      if (this.avance.misiones[2] != null && inIdsPrueba === false) {
        this.$router.push("/mision-3-resultados");
      }
    },
    async getFortaleza() {
      console.log({ reto: this.reto - 1 });
      this.avance = await this.$store.dispatch("getAvance");
      this.respuestas_usuario = [];

      this.fortaleza = this.avance.misiones[1].fortaleza;
      this.competencias = this.avance.misiones[1].competencias;

      this.competenciasObj = {};
      for (var i = 0; i < 4; i++) {
        if (this.competencias[i] != null) {
          console.log({ hey: this.competencias[i][0] });
          this.competenciasObj[this.competencias[i][0]] = this.competencias[
            i
          ][1];
        }
      }

      console.log({ fortaleza: this.fortaleza });
      console.log({ competenciasObj: this.competenciasObj });
    },
    avanzar() {
      this.setAvance();
      //this.resultado = true;
    },
    retroceder() {
      this.$router.push("/mision-3-template/" + this.reto);
    },
    async setAvance() {
      let thes = this;
      console.log({ avanzando: this.selecciones });
      this.respuestas_usuario[this.reto] = this.selecciones;

      let data = {
        index_mision: this.mision - 1,
        write: {
          mision: this.mision,
          reto: this.reto + 1,
          total: this.retos.length,
          respuestas: this.respuestas_usuario,
          resultado_evaluacion: this.resultado_evaluacion,
        },
      };

      await this.$store.dispatch("setAvance", data);

      if (this.reto + 2 <= this.retos.length) {
        this.$router.push("/mision-3-template/" + (this.reto + 2));
      } else {
        swal
          .fire({
            title: "¿Estás seguro(a) de enviar tus respuestas?",
            icon: "info",
            html:
              "Recuerda que no hay vuelta atrás, no podrás cambiar tus respuestas para este nivel más adelante. Selecciona 'No estoy seguro' para cambiar tus respuestas.",
            showCancelButton: true,
            confirmButtonText: `Sí, continuar`,
            cancelButtonText: `No estoy seguro`,
          })
          .then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              thes.confirmarRespuestas();
            }
          });
      }
    },
    async confirmarRespuestas() {
      this.respuestas_usuario[this.reto] = this.selecciones;

      let data = {
        index_mision: this.mision - 1,
        write: {
          mision: this.mision,
          reto: this.reto + 1,
          total: this.retos.length,
          respuestas: this.respuestas_usuario,
          resultado_evaluacion: this.resultado_evaluacion,
        },
      };

      await this.$store.dispatch("setAvance", data);
      this.evaluar();

      if (this.campos_aptos.length == 0) {
        swal
          .fire({
            title: "Oops",
            text:
              "Selecciona al menos un campo de conocimiento, volvamos en el tiempo...",
            icon: "warning",
            confirmButtonText: "Volvamos",
          })
          .then((result) => {
            this.$router.push("/mision-3-advertencia/");
          });

        return;
      }

      data = {
        index_mision: this.mision - 1,
        write: {
          mision: this.mision,
          reto: this.reto + 1,
          total: this.retos.length,
          respuestas: this.respuestas_usuario,
          resultado_evaluacion: this.resultado_evaluacion,
          habilidades: this.suma,
          campos_aptos: this.campos_aptos,
        },
      };

      await this.$store.dispatch("setAvance", data);
      await this.$store.dispatch("registroMision3", data);
      //this.resultado = true;

      this.$router.push("/mision-3-resultados");
    },
    evaluar() {
      let thes = this;
      this.respuestas_usuario.forEach((element) => {
        if (element.opcion1.gusto === true) {
          if (
            thes.fortaleza == "habilidad_" + element.tipo ||
            thes.competenciasObj["habilidad_" + element.tipo] != null ||
            element.opcion1.habilidad === true
          ) {
            let obj = {
              campo: element.campo,
              campo_especifico: element.opcion1.campo_especifico,
            };
            if (thes.campos_aptos.includes(obj) === false) {
              thes.campos_aptos.push(obj);
            }
          }
        }
        if (element.opcion2.gusto === true) {
          if (
            thes.fortaleza == "habilidad_" + element.tipo ||
            thes.competenciasObj["habilidad_" + element.tipo] != null ||
            element.opcion2.habilidad === true
          ) {
            let obj = {
              campo: element.campo,
              campo_especifico: element.opcion2.campo_especifico,
            };
            if (thes.campos_aptos.includes(obj) === false) {
              thes.campos_aptos.push(obj);
            }
          }
        }
      });

      console.log({ campos_aptos: this.campos_aptos });
    },

    tick() {
      if (this.resultado === true) return;

      this.time++;
      var vm = this;
      setTimeout(function () {
        vm.tick();
      }, 1000);
    },
    siguienteMision() {
      this.$router.push("/mision-1-2");
    },
    toggleOraculo() {
      this.oraculo = !this.oraculo;
    },
    selectRespuesta(index, respuesta, campo, tipo, campo_especifico) {
      console.log({ index: index, respuesta: respuesta });

      this.selecciones["opcion" + index].campo_especifico = campo_especifico;
      this.selecciones["opcion" + index][respuesta] = !this.selecciones[
        "opcion" + index
      ][respuesta];
      this.selecciones.campo = campo;
      this.selecciones.tipo = tipo;
      console.log({ selecciona_respuesta: this.selecciones });
    },
  },
};
</script>


<style lang="scss" scoped>
.mision {
  .contentabs {
    .oraculo {
      top: 0%;
      width: 34vw;
      right: 0vw;
      position: absolute;
      z-index: 100;
      cursor: pointer;
      .btnoraculo {
        width: 80%;
        margin-left: 20%;
        position: relative;
      }
      .dialogo {
        position: absolute;
        right: 0%;
        top: 0%;
        width: 120%;
        visibility: hidden;
        pointer-events: none;
        &.active {
          visibility: visible;
          pointer-events: initial;
        }
        .cerrar {
          position: absolute;
          top: 3%;
          right: 6%;
        }
        .titulo {
          position: absolute;
          width: 50%;
          margin: 0 10% 0 40%;
          top: 12%;
          height: 20%;
          display: flex;
          align-items: center;
          font-size: 1.5vw;
        }
        .texto {
          position: absolute;
          width: 80%;
          margin: 0 10%;
          top: 40%;
          font-size: 1.4vw;
        }
      }
    }
    .tiempo-score {
      position: absolute;
      bottom: 3vw;
      right: 8vw;
      width: 20vw;
    }
    .btnavanzar {
      color: white;
      top: 14.5%;
      right: 0%;
      width: 25%;
      position: absolute;
      min-height: 5vw;
      -moz-user-select: none;
      -webkit-user-select: none;
      -ms-user-select: none;
      user-select: none;
      transition: 0.25s all ease-out;
      cursor: pointer;
      img {
        width: 20vw;
        padding: 0.4vw 0.6vw;
        float: left;
        position: absolute;
        right: 0%;
        top: 50%;
        transform: translateY(-50%);
      }
      .texto {
        position: absolute;
        z-index: 100;
        top: 8%;
        left: 35%;
        min-height: 5vw;
        width: 62%;
        display: flex;
        flex-direction: column;
        align-items: left;
        justify-content: center;
        padding: 0.5vw;
        font-size: 1.1vw;
        span {
          font-size: 1.05vw;
          text-align: left;
        }
      }
      &:hover {
        transform: scale(1.1);
      }
    }
    .btnretroceder {
      color: white;
      top: 14.5%;
      left: -5%;
      width: 25%;
      position: absolute;
      min-height: 5vw;
      -moz-user-select: none;
      -webkit-user-select: none;
      -ms-user-select: none;
      user-select: none;
      transition: 0.25s all ease-out;
      cursor: pointer;
      img {
        width: 20vw;
        padding: 0.4vw 0.6vw;
        float: left;
        position: absolute;
        right: 0%;
        top: 50%;
        transform: translateY(-50%);
      }
      .texto {
        position: absolute;
        z-index: 100;
        top: 8%;
        left: 45%;
        min-height: 5vw;
        width: 62%;
        display: flex;
        flex-direction: column;
        align-items: left;
        justify-content: center;
        padding: 0.5vw;
        font-size: 0.9vw;
        span {
          font-size: 1.05vw;
          text-align: left;
        }
      }
      &:hover {
        transform: scale(1.1);
      }
    }
    .menu {
      bottom: 0%;
      left: 0%;
      right: 0%;
      width: 100%;
      position: absolute;
      .medidor {
        width: 88%;
        margin: 0 6%;
      }
      .contenedoropciones {
        position: absolute;
        bottom: 0%;
        width: 100%;
        display: flex;
        .opcionessortable {
          position: relative;
          padding-bottom: 10%;
          width: 24%;
          margin: 0 0.4%;
          float: left;
          .opcion {
            position: relative;
            .texto {
              position: absolute;
              top: 46%;
              transform: translateY(-50%);
              color: white;
              position: absolute;
              font-size: 1.1vw;
              width: 60%;
              margin: 0 20%;
              font-weight: bold;
              text-align: center;
            }
            img {
              width: 100%;
            }
          }
        }
        .opcionessortable > *.dragging {
          box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.2);
        }
      }
      &.multiple {
        left: -5%;
        width: 110%;
        .contenedoropciones {
          position: absolute;

          width: 90%;
          margin: 0 5%;
          bottom: 55%;
          .opcionesmultiple {
            position: relative;
            top: 0%;
            width: 24%;
            margin: 0 0.4%;
            float: left;
            .opcion {
              position: relative;
              .texto {
                position: absolute;
                top: 46%;
                transform: translateY(-50%);
                color: white;
                position: absolute;
                font-size: 1.1vw;
                width: 60%;
                margin: 0 20%;
                font-weight: bold;
                text-align: center;
              }
              img {
                width: 100%;
              }
            }
          }
        }
        .checks {
        }
        .check1 {
        }
        .check2 {
        }
        .check3 {
        }
        .check4 {
        }
      }
      &.seleccion {
        position: absolute;
        width: 100%;
        margin: 0 0%;
        bottom: 0%;
        z-index: 1;

        .contmedidor {
          position: relative;
          z-index: 10;
          .medidor {
            position: relative;
            width: 20%;
            margin: 0 40%;
            height: 5vw;
            .check {
              position: absolute;
              top: 4%;
              left: 4%;
              width: 9vw;
              img {
                width: 60%;
                margin: 0 20%;
                height: 80%;
                margin-top: 0%;
              }
            }
            .tache {
              position: absolute;
              top: -4%;
              left: 58%;
              width: 8vw;
              img {
                width: 50%;
                margin: 0 25%;
                height: 80%;
                margin-top: 10%;
              }
            }
          }
        }

        .contenedoropciones {
          height: 10vh;
          z-index: 1;
        }
        .opcionesseleccion {
          position: relative;
          bottom: 200%;
          width: 100%;
          margin: 0 0.4%;
          float: left;
          display: flex;
          justify-content: center;
          .opcion {
            position: relative;
            .texto {
              position: absolute;
              top: 46%;
              transform: translateY(-50%);
              color: white;
              position: absolute;
              font-size: 1.1vw;
              width: 60%;
              margin: 0 20%;
              font-weight: bold;
              text-align: center;
            }
            img {
              height: 100%;
            }
            .checkbox {
              width: 5vw;
              height: 5vw;
              left: 0%;
              text-align: center;
              .check {
                position: absolute;
                top: 12%;
                left: 3%;
                width: 100%;
                pointer-events: none;
                height: 6vh;
              }
              .tache {
                position: absolute;
                top: 20%;
                left: 2%;
                width: 100%;
                pointer-events: none;
                height: 5vh;
              }
            }
          }
        }
      }
      &.dragging {
        .tache,
        .check {
          pointer-events: none;
        }
      }
    }
    .pregunta {
      top: 0%;
      left: 8%;
      width: 72%;
      position: absolute;
      .pregunta_txt {
        top: 50%;
        transform: translateY(-50%);
        left: 0%;
        width: 70%;
        margin: 0 0 0 20%;
        position: absolute;
        div {
          font-size: 1.2vw;
        }
      }
    }
    .quasar {
      top: 4.3%;
      left: 13%;
      width: 7%;
      position: absolute;
      animation: float 6s ease-in-out infinite;
      z-index: 100;
    }

    .mensaje {
      position: absolute;
      top: -12vw;
      left: 50%;
      width: 22vw;
      z-index: -1;
      img {
        width: 100%;
      }
      .texto {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        padding: 0.3vw 1vw 0.3vw 2vw;
        display: flex;
        justify-content: center;
        align-items: center;
        div,
        span {
          font-size: 1.4vw;
        }
      }
      &.invertido {
        left: -15vw;
        .texto {
          padding: 0.3vw 1vw 0.3vw 2vw;
        }
      }
    }
    .checkbox {
      top: 94%;
      width: 20%;
      position: absolute;
      left: 40%;
      cursor: pointer;
      .check,
      .tache {
        position: absolute;
        top: 0%;
        left: 10%;
        width: 100%;
        visibility: hidden;
        pointer-events: none;
        &.active {
          visibility: visible;
        }
      }
    }
  }
}

.bg1 {
  background-image: url(../../../assets/imgs/mision/3/1/bg.jpg);
  .fortaleza span,
  .opcion div,
  .nombre span {
    color: #45ffff;
  }
}
.bg2 {
  background-image: url(../../../assets/imgs/mision/3/2/bg.jpg);
  .profesor {
    left: -4vw !important;
    img {
      width: 40vw !important;
    }
  }
  .fortaleza span,
  .opcion div,
  .nombre span {
    color: #eefd83;
  }
}
.bg3 {
  background-image: url(../../../assets/imgs/mision/3/3/bg.jpg);
  .fortaleza span,
  .opcion div,
  .nombre span {
    color: #ffe6e4;
  }
}
.bg4 {
  background-image: url(../../../assets/imgs/mision/3/4/bg.jpg);
  .fortaleza span,
  .opcion div,
  .nombre span {
    color: #ffecff;
  }
}
.bg5 {
  background-image: url(../../../assets/imgs/mision/3/5/bg.jpg);
  .fortaleza span,
  .opcion div,
  .nombre span {
    color: #fff3c5;
  }
}
.bg6 {
  background-image: url(../../../assets/imgs/mision/3/6/bg.jpg);
  .profesor {
    left: -4vw !important;
    img {
      width: 20vw !important;
    }
  }
  .fortaleza span,
  .opcion div,
  .nombre span {
    color: #bbfdff;
  }
}
.bg7 {
  background-image: url(../../../assets/imgs/mision/3/7/bg.jpg);
  .profesor {
    left: -4vw !important;
    img {
      width: 20vw !important;
    }
  }
  .fortaleza span,
  .opcion div,
  .nombre span {
    color: #eefd83;
  }
}
.bg8 {
  background-image: url(../../../assets/imgs/mision/3/8/bg.jpg);
  .profesor {
    left: -4vw !important;
    img {
      width: 20vw !important;
    }
  }
  .fortaleza span,
  .opcion div,
  .nombre span {
    color: #ffb69e;
  }
}
.bg9 {
  background-image: url(../../../assets/imgs/mision/3/9/bg.jpg);
  .fortaleza span,
  .opcion div,
  .nombre span {
    color: #b4f385;
  }
}
.bg10 {
  background-image: url(../../../assets/imgs/mision/3/10/bg.jpg);
  .profesor {
    left: -5vw !important;
    img {
      width: 40vw !important;
    }
  }
  .fortaleza span,
  .opcion div,
  .nombre span {
    color: #b2e7ff;
  }
}

.mision1_1 {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top center;
  .alien {
    bottom: 0%;
    left: 12%;
    width: 13%;
    position: absolute;
    .atomo {
      position: absolute;
      top: 0%;
      left: -40%;
      width: 150%;
      z-index: -1;
      animation: float 2s ease-in-out infinite;
    }
  }
  .smartphone {
    top: -90%;
    left: 34%;
    width: 8%;
    position: absolute;
    .atomo {
      position: absolute;
      top: -25%;
      left: -65%;
      width: 240%;
      z-index: -1;
      animation: float 2s ease-in-out infinite;
    }
  }
  .libro {
    top: -80%;
    left: 55%;
    width: 12%;
    position: absolute;
    .atomo {
      position: absolute;
      top: -65%;
      left: -40%;
      width: 180%;
      z-index: -1;
      animation: float 2s ease-in-out infinite;
    }
  }
  .guantes {
    top: -105%;
    left: 78%;
    width: 12%;
    position: absolute;
    .atomo {
      position: absolute;
      top: -25%;
      left: -45%;
      width: 180%;
      z-index: -1;
      animation: float 2s ease-in-out infinite;
    }
  }
}

.drag {
  cursor: pointer;
}

.dinamica {
  position: absolute;
  top: 28%;
  left: 5%;
  .info {
    position: relative;
    width: 26vw;
    .contenido {
      position: absolute;
      top: 0px;
      > div {
        width: 100%;
      }
      .materia {
        img {
          width: 45%;
        }
      }
      .profesor {
        position: absolute;
        bottom: -5vw;
        left: -1vw;
        img {
          width: 16vw;
        }
      }
    }
  }
  .opciones {
    position: absolute;
    top: 0px;
    width: 64vw;
    left: 28vw;
    .contenedor {
      position: absolute;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 100%;

      .fortaleza {
        position: absolute;
        top: -1%;
        width: 33%;
        height: 9%;
        padding-top: 1%;
        img {
          width: 2vw;
        }
      }

      .opcion {
        position: relative;
        top: 17%;
        height: 83%;
        width: 50%;
        float: left;

        .icono {
          position: absolute;
          top: 10%;
          img {
            height: 12vw;
          }
          .texto {
          }
        }

        .barra {
          position: absolute;
          bottom: 0.3vw;
          left: 0;
          width: 98.5%;
          margin: 0 0% 0 1%;
          background: rgba(0, 0, 0, 0.2);
          min-height: 4vw;
          .contcheck {
            span {
              width: 50%;
              text-align: right;
              margin: 5% 0;
            }
            .check {
              width: 30%;
              position: relative;
              img.box {
                max-width: 80%;
                margin: 5% 20%;
              }
              .paloma {
                position: absolute;
                width: 100%;
                height: 100%;
                top: 0;
                left: 0;
                display: flex;
                justify-content: center;
                align-items: center;
                img {
                  width: 90%;
                  margin-left: 20%;
                }
              }
            }
          }
        }
      }
      .opcion1 {
        .barra {
          background: #224389;
        }
      }
      .opcion2 {
        .barra {
          width: 99%;
          margin: 0;
          background: #082970;
        }
      }
    }
  }
}
</style>
